import { render, staticRenderFns } from "./OsReportsOverview.vue?vue&type=template&id=b77f4630&scoped=true"
import script from "./OsReportsOverview.vue?vue&type=script&lang=ts"
export * from "./OsReportsOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77f4630",
  null
  
)

export default component.exports